import { gql, useQuery } from '@apollo/client';

export const DPO_TASK_FIELDS = gql`
  fragment DpoTaskFields on DPOTask {
    id
    createdAt
    updatedAt
    dpoState
    name
    topicId
    topicTitle
    hasFile
    documentUrl
    isEnabled
    isApproved
    type
    listCategory
    questionnaireId
    deadline
    deadlineStatus
  }
`;

export const GET_DPO_TASKS = gql`
  ${DPO_TASK_FIELDS}
  query GetDpoTasks($companyId: String!) {
    getDpoTasks(companyId: $companyId) {
      ...DpoTaskFields
    }
  }
`;

export enum DpoState {
  UNTOUCHED = 'UNTOUCHED',
  TOUCHED = 'TOUCHED',
  COMPLETE = 'COMPLETE',
  AUDITED = 'AUDITED',
}

export enum DpoTaskResourceType {
  Questionnaire = 'Questionnaire',
  ListItem = 'ListItem',
}

export interface DpoTaskState {
  id: string;
  createdAt?: string;
  updatedAt?: string;
  dpoState: DpoState;
  name: string;
  topicId: string;
  topicTitle: string;
  hasFile: boolean;
  documentUrl?: string;
  isEnabled: boolean;
  isApproved: boolean;
  type: DpoTaskResourceType;
  listCategory?: string;
  questionnaireId?: string;
  // Answer deadline (Art. 12 Abs. 3 DSGVO), only set for listCategory 'rights-request'
  deadline?: string;
  deadlineStatus?: 'OPEN' | 'DUE_SOON' | 'CRITICAL' | 'OVERDUE' | 'DONE' | 'UNKNOWN';
}

export interface GetDpoTasksResult {
  getDpoTasks: DpoTaskState[];
}

export interface GetDpoTasksInput {
  companyId: string;
}

export function useDpoTasksQuery(companyId: string | undefined) {
  return useQuery<GetDpoTasksResult, GetDpoTasksInput>(GET_DPO_TASKS, {
    variables: { companyId: companyId || '' },
    skip: !companyId,
  });
}
